<template>
  <el-dialog top="10px" class="Gen" :visible.sync="isVisibleGen" width="800px" append-to-body :close-on-click-modal="false" title="生成海报">

    <div v-if="items.length > 0" style="margin-bottom: 10px">选择应用</div>
    <el-select v-if="items.length > 0" v-model="app_id" size="large" @change="changeApp" style="margin-bottom: 20px">
      <el-option v-for="item in items" :value="item.itemId" :key="item.itemId" :label="item.name"></el-option>
    </el-select>

    <div class="contentBig">



      <div class="top">

        <div class="viewImg">
          <img :src="srcImg" alt="">
          <span v-if="!srcImg">点击下方图片预览海报</span>
        </div>
        <div v-if="srcImg" class="downloadImgBtn">
          <el-button @click="downloadImg(srcImg)">下载海报</el-button>
        </div>
      </div>
      <div class="bottom">
        <div class="previewImgList" v-for="(item, index) in previewImgList" :key="index" @click="previewImgClick(item.posterId)">
          <img :src="item.thumb" alt="">
          <div class="bottomImgBtn">
            <el-button size="mini" @click="previewImgClick(item.posterId)">使用模板</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'GeneratePoster',
  data() {
    return {
      isVisibleGen: false,
      previewImgList: [],
      productionImages: '',
      srcImg: '',
      posterId: '',
      targetId: '',
      targetType: '',
      app_id: '',
      items:[],
    }
  },
  methods: {
    init(targetId, targetType) {
      this.srcImg = ''
      this.targetId = targetId
      this.targetType = targetType
      this.getItemList();
      this.posterOptions()
      this.isVisibleGen = true

    },

    changeApp(e){
      this.app_id = e;
    },
    getItemList: function () {
      let t = this;
      this.$get(
        {
          context: t,
          path: '/app/list/',
          params: {
            qrcode: 1
          },
          success: function (data) {
            t.items = data.items;
          }
        }
      )
    },

    // 预览海报 列表
    posterOptions() {
      let t = this;
      this.$post(
        {
          context: t,
          loading: true,
          path: '/poster/options/',
          params: {
            type: this.targetType,
          },
          success: function (data) {
            t.previewImgList = data.options
            if (t.previewImgList.length > 0) {
              //t.posterMerge(t.previewImgList[0])
            }
          }
        }
      )
    },
    // 生成海报
    posterMerge(e) {
      if (this.app_id === ''){
        this.$message({
          type: 'error',
          message: '应用未选择'
        });
        return;
      }
      let t = this;
      this.$post(
        {
          context: t,
          loading: true,
          path: '/poster/merge/',
          params: {
            app_id: this.app_id,
            poster_id: e ? e.posterId : this.posterId,
            target_id: this.targetId,
            type: this.targetType,
          },
          success: function (data) {
            t.srcImg = data.image
          }
        }
      )

    },
    // 点击生成海报按钮
    previewImgClick(e) {
      this.posterId = e
      this.posterMerge()
    },
    downloadImg(e) {
      this.downloadIamge(e, '图片')
    },
    // 下载文件
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') //得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    }
  }
}
</script>

<style scoped>
.contentBig {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 650px;
}
.top {
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: #f6f6f6;
}
.viewImg {
  width: 220px;
  height: 400px;
}
.viewImg img {
  width: 100%;
}
/* .downloadImgBtn {
  width: 100%;
  display: flex;
  justify-content: center;
} */
.bottom {
  width: 100%;
  height: 249px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.previewImgList {
  display: inline-block;
  align-items: center;
  cursor: pointer;
  margin: 10px;
  width: 100px;
  height: 180px;
}
.previewImgList img {
  width: 100%;
}
.previewImgList .bottomImgBtn {
  /* position: fixed;
  bottom: 13%; */
  text-align: center;
  margin: 5px 0;
}
::v-deep ::-webkit-scrollbar {
  width: 10px; /* 竖轴宽度 */
  height: 12px; /* 横轴宽度 */
  /* background-color: #041c34; */
}
::v-deep ::-webkit-scrollbar-track {
  border-radius: 10px;
}
</style>
